<template>
  <FlatActionButton
    :action="openModal"
    :buttonClass="['btnDefault']"
    :text="'View Reply Attributes'"
  />
</template>

<script>
import { ItemTypeConsts, ItemTypeDisplayNames, StoreModelMap } from 'client/util/Constants';
import { mapActions } from 'vuex';
import { notify } from 'client/util';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import RadiusUserGroupsAttributesModal from 'client/components/Modal/RadiusUserGroupsAttributesModal.vue';

const userGroupModel = StoreModelMap[ItemTypeConsts.userGroup];

export default {
  name: 'RadiusViewAttributesButton',

  components: {
    FlatActionButton,
  },

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  methods: {
    ...mapActions(userGroupModel, [
      'fetchItem',
      'updateItem',
    ]),

    openModal() {
      try {
        this.updateItem({ id: this.item.id });
        this.fetchItem(this.item.id);
        // updateItem and fetchItem are both required to update the store values of the
        // given user group
        ModalEventBus.open({
          component: RadiusUserGroupsAttributesModal,
          componentProps: {
            item: this.item,
          },
        });
      } catch {
        notify('error', `Unable to retrieve ${ItemTypeDisplayNames[this.item.type].toLowerCase()} data. Please refresh the page and try again.`);
      }
    },
  },
};
</script>
